import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { NplexAnswersResult } from '../dtos/nplex-answers-result.dto';
import { ComplianceLimitsResult } from '../dtos/compliance-limits-result.dto';
import { NplexAnswersCombinedResult } from '../dtos/nplex-answers-combined-result.dto';

@Injectable({
  providedIn: 'root',
})
export class NplexAnswersService {
  private readonly baseUrl: string = '';
  private readonly nplexanswersPath: string = 'nplexanswers/V1';
  private readonly compliancelimitsPath: string = 'compliancelimits/V1';
  private readonly nplexanswerscombinedPath: string = 'nplex-answers';

  private complianceLimitsResults: ComplianceLimitsResult[] = [];
  private nplexAnswersCombinedResults: NplexAnswersCombinedResult[] = [];
  private nplexAnswersResults: NplexAnswersResult[] = [];
  private transactionId: string = '';

  constructor(private readonly httpClient: HttpClient) {
    this.baseUrl = environment.apiUrl || 'http://localhost:8080';
  }

  getComplianceLimits(
    transactionSid: string
  ): Observable<Array<ComplianceLimitsResult>> {
    return this.httpClient.get<Array<ComplianceLimitsResult>>(
      `${this.baseUrl}/${this.compliancelimitsPath}`,
      {
        params: {
          transaction_sid: transactionSid,
        },
      }
    );
  }

  getNplexAnswersCombined(
    transactionSid: string,
    lastName: string
  ): Observable<Array<NplexAnswersCombinedResult>> {
    return this.httpClient.get<Array<NplexAnswersCombinedResult>>(
      `${this.baseUrl}/${this.nplexanswerscombinedPath}`,
      {
        params: {
          transaction_sid: transactionSid,
          last_name: lastName,
        },
      }
    );
  }

  getNplexAnswers(
    transactionSid: string,
    lastName: string
  ): Observable<Array<NplexAnswersResult>> {
    return this.httpClient.get<Array<NplexAnswersResult>>(
      `${this.baseUrl}/${this.nplexanswersPath}`,
      {
        params: {
          transaction_sid: transactionSid,
          last_name: lastName,
        },
      }
    );
  }

  public getComplianceLimitsResults(): ComplianceLimitsResult[] {
    return this.complianceLimitsResults;
  }

  public setComplianceLimitsResults(
    complianceLimitsResults: ComplianceLimitsResult[]
  ) {
    this.complianceLimitsResults = complianceLimitsResults;
  }

  public getNplexAnswersCombinedResults(): NplexAnswersCombinedResult[] {
    return this.nplexAnswersCombinedResults;
  }

  public setNplexAnswersCombinedResults(
    nplexAnswersCombinedResults: NplexAnswersCombinedResult[]
  ) {
    this.nplexAnswersCombinedResults = nplexAnswersCombinedResults;
  }

  public getNplexAnswersResults(): NplexAnswersResult[] {
    return this.nplexAnswersResults;
  }

  public setNplexAnswersResults(nplexAnswersResults: NplexAnswersResult[]) {
    this.nplexAnswersResults = nplexAnswersResults;
  }

  public getTransactionId(): string {
    return this.transactionId;
  }

  public setTransactionId(transactionId: string): void {
    this.transactionId = transactionId;
  }
}
